'use client';

import React, { useState } from 'react';
import dynamic from 'next/dynamic';

import { ChartSkeleton } from '@/components/ui/LoadingSkeleton';

const ActivityTrendChart = dynamic(() => import('./ActivityTrendChart'), {
  ssr: false,
  loading: () => <ChartSkeleton height={260} />,
});

const CentreComparisonChart = dynamic(() => import('./CentreComparisonChart'), {
  ssr: false,
  loading: () => <ChartSkeleton height={260} />,
});

export default function DashboardCharts() {
  const [activeChart, setActiveChart] = useState<'trend' | 'comparison'>('trend');

  return (
    <div className="bg-card rounded-2xl border border-border shadow-card p-5 h-full">
      <div className="flex items-center justify-between mb-5 flex-wrap gap-2">
        <div>
          <h2 className="text-base font-bold text-foreground">Activity Overview</h2>
          <p className="text-xs text-muted-foreground mt-0.5">Nov 2025 – Apr 2026</p>
        </div>
        <div className="flex items-center gap-1 bg-muted rounded-xl p-1">
          <button
            onClick={() => setActiveChart('trend')}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all duration-150 ${activeChart === 'trend' ? 'tab-active' : 'tab-inactive'}`}
          >
            Trend
          </button>
          <button
            onClick={() => setActiveChart('comparison')}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all duration-150 ${activeChart === 'comparison' ? 'tab-active' : 'tab-inactive'}`}
          >
            By Centre
          </button>
        </div>
      </div>

      {activeChart === 'trend' ? <ActivityTrendChart /> : <CentreComparisonChart />}
    </div>
  );
}